export const projectId = process.env.REACT_APP_PROJECT_ID
  ? process.env.REACT_APP_PROJECT_ID
  : "";

export const privateKey: string = process.env.REACT_APP_PROJECT_KEY
  ? process.env.REACT_APP_PROJECT_KEY
  : "";
